import { render, staticRenderFns } from "./SesionExpirada.vue?vue&type=template&id=23ae65ad&scoped=true&"
import script from "./SesionExpirada.vue?vue&type=script&lang=js&"
export * from "./SesionExpirada.vue?vue&type=script&lang=js&"
import style0 from "./SesionExpirada.vue?vue&type=style&index=0&id=23ae65ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae65ad",
  null
  
)

export default component.exports